import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  IGetApontamentoResponse,
  IApontamentoResponse,
  IPessoaData,
  ITableData,
} from './apontamento-layout.model';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { AppExportBase64 } from '../../../../services/exportBase64/exportBase64.service';
import { PermissionService } from '../../../../services/permission.service';
import { HttpService } from '../../../../services/common/http/common.http.service';
import {
  formatCpf,
  getFuncionarioId,
} from '../../../../utils/utility-functions';
import * as signalR from '@microsoft/signalr';
import { HubConnectionService } from '../../../../services/ping/hubConnection.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-apontamento-layout',
  templateUrl: './apontamento-layout.component.html',
  styleUrls: ['./apontamento-layout.component.scss'],
})
export class ApontamentoLayoutComponent implements OnInit, OnDestroy {
  permission: number = 2;
  tableData: ITableData[] | Array<any> = [];
  pessoaData: IPessoaData = {};
  visibleHorariosApontados: boolean = false;
  visibleExtracaoRelatorio: boolean = false;
  visibleUploadLista: boolean = false;
  expandirCardsMobile: boolean = false;
  loader: boolean = false;

  pesquisaParams = {
    TxPesquisar: '',
    Situacao: '',
    DtInicio: '',
    DtFim: '',
    Pagina: 0,
    TamanhoPagina: 8,
    MaxPages: 1,
  };

  situacaoOptions = [
    {
      name: 'Todos',
      value: '',
    },
    {
      name: 'Completo',
      value: 'Completo',
    },
    {
      name: 'Incompleto',
      value: 'Incompleto',
    },
    {
      name: 'Faltante',
      value: 'Faltante',
    },
  ];

  hubName = 'pingHubPointing';
  hubReceiveName = 'pingHubPointingReceive';

  constructor(
    private httpService: HttpService,
    private permissionService: PermissionService,
    private router: Router,
    private toast: ToastrService,
    private exportBase64Service: AppExportBase64,
    private hubConnectionService: HubConnectionService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}
  ngOnDestroy(): void {
    this.hubConnectionService.stopConnection();
  }

  ngOnInit() {
    this.permission = this.permissionService.getPermission();
    this.getApontamentos();
    this.changeDetectorRef.detectChanges();

    this.hubConnectionService.configureHub(this.hubName, this.hubReceiveName);
    this.hubConnectionService
      .getMessages()
      .subscribe((msg) => this.toast.info(msg.message));
  }
  tableColumns = [
    {
      header: 'Nome e CPF',
      key: '',
      keyArray: ['nome', 'cpf'],
      type: 'textArray',
    },
    { header: 'Tipo de Contratação', key: 'tipoContratacao', type: 'text' },
    { header: 'Data', key: 'data', type: 'text' },
    {
      header: 'Situação',
      key: 'situacao',
      type: 'text',
    },
    {
      header: 'Advertência',
      key: 'advertencia',
      type: 'buttons',
      buttons: [
        {
          label: 'Cadastrar',
          secondaryLabel: 'Editar',
          conditionSecLabel: (item: ITableData) =>
            item?.advertencia == null ? false : true,
          action: (item: ITableData) => this.visualizarAdvertencia(item),
          condition: (item: ITableData) => this.advertenciaMotivo(item),
        },
      ],
    },
    {
      header: 'Ajuste',
      key: 'ajuste',
      type: 'switch',
      action: (item: ITableData) => this.navigateAjuste(item),
      condition: (item: ITableData) => true,
    },
    {
      header: 'Ações',
      key: 'acoes',
      type: 'buttons',
      buttons: [
        {
          img: 'assets/images/info-circle.svg',
          label: 'Horários',
          action: (item: ITableData) => this.verHorarios(item),
          condition: (item: ITableData) => true,
        },
      ],
    },
  ];

  rowsMobile = [
    { header: 'Nome', key: 'nome', type: 'text', default: true },
    {
      header: 'CPF',
      key: 'cpf',
      type: 'text',
      default: true,
      style: 'blue',
    },
    { header: 'Data', key: 'data', type: 'text' },
    {
      header: 'Ajuste',
      key: 'ajuste',
      type: 'switch',
      action: (item: ITableData) => this.navigateAjuste(item),
      condition: (item: ITableData) => true,
    },
    {
      header: 'Situação',
      key: 'situacao',
      type: 'text',
    },
    {
      header: 'Advertência',
      key: 'advertencia',
      type: 'buttons',
      buttons: [
        {
          label: 'Cadastrar',
          secondaryLabel: 'Editar',
          conditionSecLabel: (item: ITableData) =>
            item?.advertencia == null ? false : true,
          action: (item: ITableData) => this.visualizarAdvertencia(item),
          condition: (item: ITableData) => this.advertenciaMotivo(item),
        },
      ],
    },
    {
      header: 'Ações',
      key: 'acoes',
      type: 'buttons',
      buttons: [
        {
          img: 'assets/images/info-circle.svg',
          label: 'Horários',
          action: (item: ITableData) => this.verHorarios(item),
          condition: (item: ITableData) => true,
        },
      ],
    },
  ];

  advertenciasituacao(item?: any): any {
    if (!item.situacao) {
      return false;
    }
    return true;
  }

  advertenciaMotivo(item?: any): any {
    if (!item.apontamento) {
      return false;
    }
    return true;
  }

  visualizarAdvertencia(item: ITableData) {
    let status = 1;
    status = item.divergencia !== null ? 1 : 2;

    this.router.navigate(['encarregado/advertencia'], {
      queryParams: {
        idAdvertencia: item.advertencia,
        idPessoa: item.idPessoa,
        ApontamentoHoraId: item.id,
        isMode: status,
      },
    });
  }

  visualizarsituacao(item: any) {
    this.router.navigate(['encarregado/divergencia'], {
      queryParams: {
        idAdvertencia: item.justificativa,
        idPessoa: item.idPessoa,
        ApontamentoHoraId: item.apontamento,
        isMode: 0,
      },
    });
  }

  navigatePonto() {
    this.router.navigate(['encarregado/ponto']);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.getApontamentos();
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getHours(date?: Date) {
    if (date !== null) {
      return moment(date).format('HH:mm');
    }
    return '--';
  }

  getDate(date?: Date) {
    if (date !== null) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '--';
  }

  getApontamentos() {
    this.loader = true;
    const params = this.pesquisaParams;

    this.httpService.useGet('ApontamentosByFilters', params).subscribe({
      next: (response: IGetApontamentoResponse) => {
        this.loader = false;
        const data = response.DataSet;

        if (data == null) {
          this.loader = false;

          Swal.fire({
            title: 'Registro não encontrado',
            icon: 'warning',
            text: 'Não foi encontrado registros para o filtro selecionado.',
            confirmButtonText: 'Confirmar',
            confirmButtonColor: 'green',
          });

          return;
        }

        this.tableData = response.DataSet.map((item) => {
          return {
            id: item.ApontamentoId ?? 0,
            nome: item.TxNome,
            ajuste: item.FlSolicitacaoAjuste,
            cpf: formatCpf(item.TxCPF),
            tipoContratacao: item.TipoPessoaId == 1 ? 'CLT' : 'Reeducando',
            alocacao: this.formatarCampos(item.NmFrente),
            data: this.getDate(item.DtCriacao),
            entrada: this.getHours(item.DtEntrada),
            pausa: this.getHours(item.DtSaidaAlmoco),
            volta: this.getHours(item.DtRetornoAlmoco),
            saida: this.getHours(item.DtSaida),
            entradaExtra: this.getHours(item.DtEntradaExtra),
            saidaExtra: this.getHours(item.DtSaidaExtra),
            situacao: item.TxSituacao,
            idPessoa: item.IdPessoa,
            advertencia: item.AdvertenciaId,
            divergencia: item.DivergenciaId,
            apontamento: item.ApontamentoId,
          };
        });
        this.pesquisaParams.MaxPages =
          Math.ceil(response.Total / this.pesquisaParams.TamanhoPagina) || 1;
      },
      error: (_error: any) => {
        this.loader = false;
        this.toast.error(
          'Não foi possível buscar apontamentos. Tente novamente!'
        );
      },
    });
  }

  extracaoAdvertencia() {
    this.loader = true;
    const body = {
      TxPesquisar: this.pesquisaParams.TxPesquisar.toLowerCase(),
    };

    this.httpService.usePostFilter('AdvertenciaXslx', body).subscribe({
      next: (response: any) => {
        Swal.fire({
          title: 'E-mail enviado com sucesso!',
          icon: 'success',
          text: 'Verifique sua caixa de e-mail para visualização da planilha de apontamento. (Verifique a caixa de spam)',
          confirmButtonColor: 'green',
          confirmButtonText: 'Confirmar',
        });

        this.loader = false;
      },
      error: (_error) => {
        this.toast.error('Ocorreu um erro ao exportar excel. Tente novamente!');
        this.loader = false;
      },
    });
  }

  apontamentoDiario() {
    this.loader = true;

    this.httpService.usePostFilter('PessoasApontamentoToXlsx', {}).subscribe({
      next: (response: any) => {
        Swal.fire({
          title: 'E-mail enviado com sucesso!',
          icon: 'success',
          text: 'Verifique sua caixa de e-mail para visualização da planilha de apontamento. (Verifique a caixa de spam)',
          confirmButtonColor: 'green',
          confirmButtonText: 'Confirmar',
        });

        this.loader = false;
      },
      error: (_error) => {
        this.toast.error('Ocorreu um erro ao exportar excel. Tente novamente!');
        this.loader = false;
      },
    });
  }

  extracaoRelatorio() {
    this.visibleExtracaoRelatorio = !this.visibleExtracaoRelatorio;
  }

  uploadLista() {
    this.visibleUploadLista = !this.visibleUploadLista;
  }

  verHorarios(item?: any) {
    this.pessoaData = item;
    this.visibleHorariosApontados = !this.visibleHorariosApontados;
  }

  navigateAjuste(item: ITableData) {
    this.loader = true;
    const body = {
      IdApontamento: item.id,
      FlSolicitacaoAjuste: !item.ajuste,
      FuncionarioAjusteApontamentoId: getFuncionarioId(),
      PessoaId: item.idPessoa,
    };

    this.httpService.usePatchNoParams('ApontamentoHoraAjuste', body).subscribe({
      next: () => {
        this.getApontamentos();
        Swal.fire({
          title: 'Alteração realizada',
          icon: 'success',
          text: item.ajuste
            ? 'Remoção da solicitação de ajuste realizada com sucesso'
            : 'Solicitação de ajuste realizada com sucesso.',
          confirmButtonColor: 'green',
          confirmButtonText: 'Confirmar',
        });
      },
      error: () => {
        Swal.fire({
          title: 'Atenção',
          icon: 'warning',
          text: 'Ocorreu um erro ao realizar a alteração da solicitação.',
          confirmButtonColor: 'green',
          confirmButtonText: 'Confirmar',
        });

        this.loader = false;
      },
    });
  }

  timer: ReturnType<typeof setTimeout> | null = null;
  onChangeSearch() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.getApontamentos();
    }, 800);
  }
}
